<template>
  <div class="update-profile-page">
    <ModalDiversityInputs  />

    <Hero
      image="banner.jpg"
      layout="md"
      title="Atualização de Perfil"
    />

    <div class="row pb-5">
      <div class="col-12 col-lg-10 mx-auto mt-n4">
        <div class="bg-white shadow-sm p-4 p-md-5 rounded-xl position-relative" style="overflow: hidden;">
          <LoaderContent
            v-if="!graphql_loaded"
            :welcomeMessage="false"
            :alignSpinnerTop="true"
          />

          <div v-else>

            <div v-if="updateForms[currentForm] == 'personal_data'">
              <FormPersonalData ref="formPersonalData" />
            </div>

            <div v-if="updateForms[currentForm] == 'education'">
              <BoxEducation format="modal-form" />
            </div>

            <div v-if="updateForms[currentForm] == 'professional_xp'">
              <BoxProfessionalExp format="modal-form" />
            </div>

            <div v-if="updateForms[currentForm] == 'languages'">
              <BoxLanguage />
            </div>

            <div v-if="updateForms[currentForm] == 'questions'">
              <FormQuestions :questionsByParams="questions" />
            </div>

          </div>
        </div>
      </div>

      <div class="col-12 mt-3 text-center" v-if="graphql_loaded">
        <button
          @click="prevForm()"
          class="btn btn-lg"
          :disabled="isSaving"
          v-if="hasPrevForm"
        >
          Voltar
        </button>
        <button
          @click="nextForm()"
          class="btn btn-lg btn-blue-ml"
          :disabled="isSaving"
        >
          Continuar
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";
import ModalDiversityInputs from "@/components/ModalDiversityInputs.vue";
import FormPersonalData from "ninenine-white-label/src/components/PersonalData/FormPersonalData.vue";
import BoxEducation from "ninenine-white-label/src/components/Education/BoxEducation.vue";
import BoxProfessionalExp from "ninenine-white-label/src/components/ProfessionalExp/BoxProfessionalExp.vue";
import BoxLanguage from "ninenine-white-label/src/components/Language/BoxLanguage.vue";
import FormQuestions from "ninenine-white-label/src/components/Questions/FormQuestions.vue";

export default {
  name: "UpdateProfile",

  data() {
    return {
      graphql_loaded: false,
      isSaving: false,
      currentForm: 0,
      updateForms: [],
      questions: [],
      questionsUpdateId: null,
      opportunityId: null,
    };
  },

  computed: {
    hasPrevForm() {
      return this.currentForm > 0;
    },

    hasNextForm() {
      return this.updateForms.length > this.currentForm + 1;
    }
  },

  components: {
    Hero,
    LoaderContent,
    ModalDiversityInputs,
    FormPersonalData,
    BoxEducation,
    BoxProfessionalExp,
    BoxLanguage,
    FormQuestions,
  },

  mounted() {
    let requestDomainReturn = "";

    if (this.$store.state.domains.countries.length == 0) {
      requestDomainReturn += `countries { id, name },`;
    }

    requestDomainReturn += `genders { id, description },`;
    requestDomainReturn += `raceAndEthnicities { id, description },`;
    requestDomainReturn += `pronouns { id, description },`;
    requestDomainReturn += `personalIncomes { id, description },`;
    requestDomainReturn += `familyIncomes { id, description },`;
    requestDomainReturn += `sexualOrientations {id, description},`;
    requestDomainReturn += `disabilities { id, name },`;

    if (this.$store.state.domains.maritalStatus.length == 0) {
      requestDomainReturn += `maritalStatus {id, description},`;
    }
    if (this.$store.state.domains.states.length == 0) {
      requestDomainReturn += `states { id, name, abbr },`;
    }
    if (this.$store.state.domains.education_levels.length == 0) {
      requestDomainReturn += `educationLevels {id, description},`;
    }
    if (this.$store.state.domains.education_periods.length == 0) {
      requestDomainReturn += `educationPeriods {id, description},`;
    }
    if (this.$store.state.domains.education_status.length == 0) {
      requestDomainReturn += `educationStatus {id, description},`;
    }

    if (this.$store.state.domains.companies.length == 0) {
      requestDomainReturn += `companies {id, name},`;
    }
    if (this.$store.state.domains.professional_experience_areas.length == 0) {
      requestDomainReturn += `professionalExperienceAreas {id, name},`;
    }
    if (this.$store.state.domains.professional_experience_levels.length == 0) {
      requestDomainReturn += `professionalExperienceLevels {id, name}`;
    }

    if (this.$store.state.domains.cause_experience_areas.length == 0) {
      requestDomainReturn += `causeExperienceAreas {id, description},`;
    }

    if (this.$store.state.domains.language_proficiencies.length == 0) {
      requestDomainReturn += `languageProficiencies {id, description},`;
    }

    if (requestDomainReturn.length > 0) {
      requestDomainReturn = `domains {
          ${requestDomainReturn}
        },`;
    }

    this.$store
      .dispatch(
        "graphql_queries/query",
        `
        ${requestDomainReturn}
        user( id: "${this.$store.state.user.profile.id}" ){
          avatar,
          medicalReports {
            id,
            name,
            file
          },
          profile{
            firstname,
            lastname,
            socialName,
            email,
            nationality,
            cpf,
            passport,
            gender,
            sexualOrientation,
            raceAndEthnicity,
            pronoun,
            personalIncome,
            familyIncome,
            sexualOrientation,
            descriptionHelpSelectionProcess,
            needHelpSelectionProcess,
            maritalStatus,
            phone,
            birthday,

            location {
              zipcode,
              street,
              number,
              complement,
              neighborhood,
              stateId,
              city
            },

            hasDisability,

            disabilities {
              disabilityId,
              name
            },

            educations {
              id,
              institutionName,
              level,
              courseName,
              startDate,
              endDate,
              stateId
            },

            professionalExperiences {
              id,
              role,
              responsabilities,
              company,
              startYear,
              endYear
            },

            languageProficiencies {
              id,
              language,
              proficiency
            },

            additionalQuestions {
              id,
              question,
              answer,
              slug
            }

          }
        },
      `
      )
      .then((results) => {
        setTimeout(() => this.$EventBus.$emit("editingPersonalData"), 100);
      });

    this.$store.dispatch("graphql_queries/query", `
      profileQuestionUpdate(userId: ${this.$store.state.user.profile.id}, profileQuestionUpdateIdToken: "${this.$route.params.token}") {
        id
        valid
        messageValidDate
        profile
        opportunityId
        questions {
          id
          title
          required
          candidate
          hint
          htmlType
          options
          slug
        }
      }
    `).then(async (response) => {
      if(response && response.profileQuestionUpdate) {
        this.questionsUpdateId = response.profileQuestionUpdate.id
        this.opportunityId = response.profileQuestionUpdate.opportunityId

        if(response.profileQuestionUpdate.valid == false){
          const msgError = "Solicitação fora do prazo"

          this.$swal('', msgError, 'error').then(() => {
            this.$router.push(`/`);
          });

          return;
        }

        this.updateForms = response.profileQuestionUpdate.profile || []
        // Nem todos os retornos tem formulário no WL, então filtramos apenas os possíveis
        this.updateForms = this.updateForms.filter((f) => ['personal_data', 'education', 'professional_xp', 'languages', 'questions'].includes(f))

        if(response.profileQuestionUpdate.questions){
          this.updateForms.push('questions')
          this.questions = response.profileQuestionUpdate.questions
        }

        this.graphql_loaded = true;
      } else {
        this.$swal(
          "",
          "Você já atualizou seu perfil!",
          "success"
        ).then(() => {
          this.$router.push(`/`);
        });
      }
    })
  },

  methods: {
    async validateAndSavePersonalData(){
      let canSubmit = false;

      this.isSaving = true;
      this.$EventBus.$emit("storePersonalDataForm");

      if (this.$store.state.personalDataForm.error) {
        canSubmit = false;
      } else {
        const personalData = this.$store.state.personalDataForm.data;
        const savePersonal = personalData ? await this.$store.dispatch("user/personalDataUpdate", personalData) : null;

        if (savePersonal && savePersonal.error) {
          canSubmit = false;

          this.$swal(
            "Uoops",
            "Ocorreu um erro ao salvar suas informações",
            "error"
          );
        } else{
          canSubmit = true;
        }
      }

      this.isSaving = false;
      return canSubmit;
    },

    async validateAndSaveEducations(){
      let canSubmit = false;

      this.isSaving = true;

      if (this.$store.state.user.profile.educations.length == 0) {
        canSubmit = false;
        this.$swal("Uoops", "Informe ao menos uma formação", "error");
      } else {
        canSubmit = true;
      }

      this.isSaving = false;
      return canSubmit;
    },

    async validateAndSaveProfessionalExperience(){
      let canSubmit = false;

      this.isSaving = true;

      if (
        this.$store.state.flag_no_professional_experience == false &&
        this.$store.state.user.profile.professionalExperiences.length == 0 &&
        this.$store.state.flag_no_professional_experience == false
      ) {
        canSubmit = false;
        this.$swal("Uoops", "Informe sua experiência profissional", "error");
      } else {
        canSubmit = true;
      }

      this.isSaving = false;
      return canSubmit;
    },

    async validateAndSaveQuestions(){
      let canSubmit = false;

      this.isSaving = true;

      this.$EventBus.$emit("storeQuestions");

      if (this.$store.state.opportunityQuestionsForm.error) {
        canSubmit = false;
      } else {
        canSubmit = true;
      }

      this.isSaving = false;
      return canSubmit;
    },

    prevForm(){
      this.currentForm--;
    },

    async nextForm(){
      let canNext = false;

      if(this.updateForms[this.currentForm] == 'personal_data'){
        const validatePersonalData = await this.validateAndSavePersonalData()
        canNext = validatePersonalData == true;
      } else if(this.updateForms[this.currentForm] == 'education'){
        const validateEducations = await this.validateAndSaveEducations()
        canNext = validateEducations == true;
      } else if(this.updateForms[this.currentForm] == 'professional_xp'){
        const validateProfessionalExperience = await this.validateAndSaveProfessionalExperience()
        canNext = validateProfessionalExperience == true;
      } else if(this.updateForms[this.currentForm] == 'languages'){
        canNext = true
      } else if(this.updateForms[this.currentForm] == 'questions'){
        const validateQuestions = await this.validateAndSaveQuestions()
        canNext = validateQuestions == true;
      }

      if(canNext){
        if(this.hasNextForm){
          this.currentForm++;
        } else{
          this.finish()
        }
      }
    },

    async finish(){
      this.isSaving = true;
      const msgSuccess = 'Perfil atualizado com sucesso!'
      const msgError = 'Ocorreu um erro ao atualizar seu perfil. Tente novamente.'

      if(!this.updateForms.includes('questions')){
        this.$swal('', msgSuccess, 'success').then(() => {
          this.$router.push(`/`);
        });

        return;
      }

      const questions = this.$store.state.opportunityQuestionsForm.data.questions
      const updateQuestions = await this.$store.dispatch("user/questionUpdate", {
        questions_update_id: this.questionsUpdateId,
        user_id: this.$store.state.user.profile.id,
        opportunity_id: this.opportunityId,
        questions: questions,
      });

      if(updateQuestions.data && updateQuestions.data.questionUpdate && updateQuestions.data.questionUpdate.success){
        this.$swal('', msgSuccess, 'success').then(() => {
          this.$router.push(`/`);
        });
      } else{
        this.$swal('', msgError, 'error').then(() => {
          this.$router.push(`/`);
        });
      }
    }
  },
};
</script>